"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addEntityToCategory = void 0;
// FIXME: sanitize / hide interfaces that assert the wrong way around, maybe attach this elsewhere for discoverability
/**
 * @public
 */
function addEntityToCategory(category, entity, graphicsComponent, hooks) {
    category.addEntity(entity, graphicsComponent, hooks);
}
exports.addEntityToCategory = addEntityToCategory;
//# sourceMappingURL=add-entity-to-category.js.map